export const KEY_ENTER = 'Enter' as const;

export const BOLD = 'bold' as const;
export const ITALIC = 'italic' as const;
export const UNDERLINE = 'underline' as const;
export const STRIKETHROUGH = 'strikethrough' as const;
export const CLEAR_FORMATTING = 'clearFormatting' as const;

export const HOTKEYS = [
  [
    'mod+b',
    BOLD,
  ] as const,
  [
    'mod+i',
    ITALIC,
  ] as const,
  [
    'mod+u',
    UNDERLINE,
  ] as const,
  [
    'mod+s',
    STRIKETHROUGH,
  ] as const,
];
